import { useTranslation } from 'react-i18next'

import Button from '../../../../Button'
import { QA_NAME_APPLICANT_BOARD_MORE } from '../../RentalPortalApplicants.constants'

import {
  getApplicantsBoardColumnContent,
  getApplicantsBoardColumnState,
  getHasApplicantsBoardColumnMore,
} from './RentalPortalApplicantsBoardColumn.utils'
import { RentalPortalApplicantsBoardColumnHeader } from './RentalPortalApplicantsBoardColumnHeader'

import * as styles from './RentalPortalApplicantsBoardColumn.module.css'

function RentalPortalApplicantsBoardColumn({
  column,
  isLoading,
  stage,
  onClickCard,
  onMouseDownCard,
  onShowMore,
}) {
  const { t } = useTranslation()

  const { hiddenCount, items, total } = getApplicantsBoardColumnState(column)

  function handleClickMore() {
    onShowMore(stage)
  }

  return (
    <div className={styles.RentalPortalApplicantsBoardColumn}>
      <RentalPortalApplicantsBoardColumnHeader
        isLoading={isLoading}
        stage={stage}
        total={total}
      />
      <div className={styles.track}>
        {getApplicantsBoardColumnContent({
          isLoading,
          items,
          onClickCard,
          onMouseDownCard,
        })}
      </div>
      {!isLoading && getHasApplicantsBoardColumnMore(hiddenCount) ? (
        <Button.Text
          className={styles.moreButton}
          qaName={QA_NAME_APPLICANT_BOARD_MORE}
          text={t('RentalPortal.ListingBoardMoreCountKey', {
            count: hiddenCount,
          })}
          onClick={handleClickMore}
        />
      ) : null}
    </div>
  )
}

export default RentalPortalApplicantsBoardColumn
